module.exports = __webpack_public_path__ + "img/snapshot-click.85acb255.png";